import React from 'react';
import { useSelector } from 'react-redux';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { sendStylePackSlackMessage } from '../../utils/slack';
import { showAlert } from '../general-components/alert-service';
import { GreenroomState as GS } from '../../stores/types/types';

export interface StylePacksInfoProps {
	stylePackName: string;
	existingMargin?: true;
}

export interface InfoMap {
	[key: string]: string;
}

export default function StylePackRequestBtn(props: StylePacksInfoProps) {
	const {
		stylePackName,
		existingMargin,
	} = props;

	const user = useSelector((s: GS) => s.SessionReducer.user);

	const requestStyling = async (type: string) => {
		if (!user) return;

		const storedString = localStorage.getItem(`stylepack-request-${type}`);
		if (storedString) { // they have already sent it
			const stored = JSON.parse(storedString);
			if (stored.expiration > Date.now()) { // it hasn't expired
				showAlert({
					message: 'Stylepack requested',
					description: 'We\'ve notified your account manager',
					type: 'stylepack-request',
					duration: 7000,
				});

				return;
			}
		}

		try {
			const response = await sendStylePackSlackMessage(type, user);
			if (response) {
				showAlert({
					message: 'Stylepack Requested',
					description: 'We\'ve notified your account manager.',
					type: 'stylepack-request',
					duration: 7000,
				});

				localStorage.setItem(`stylepack-request-${type}`, JSON.stringify({
					saved: true,
					expiration: Date.now() + (1000 * 60 * 5), // five minutes
				}));
			}
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<div
			className="style-pack-content-request-styling"
			style={{ marginLeft: existingMargin ? '-24px' : 0 }}
		>
			<div
				className="style-pack-content-request-styling-button"
				onClick={() => {
					requestStyling(stylePackName);
				}}
			>
				Request this styling
				<Icon
					name={ICONS.EXPAND}
					size={16}
					color={COLORS.BLACK}
				/>
			</div>
		</div>
	);
}
